
import { defineComponent } from "vue";
import { useStore } from "vuex";
import TeamStatistics from "./TeamStatistics.vue";
import RankingStatistics from "./RankingStatistics.vue";
import GeneralStatistics from "./GeneralStatistics.vue";
import AccessesStatistics from "./AccessStatistics.vue";
import { isCirculoTemplate } from "../../mixins";

export default defineComponent({
  name: "UserStatistics",
  components: {
    AccessesStatistics,
    GeneralStatistics,
    RankingStatistics,
    TeamStatistics
  },

  setup() {
    const store = useStore();

    return {
      store,
      isCirculoTemplate
    };
  }
});
